import { useModals } from "ModalProvider";
import Button from "components/base/Button";
import TextEditor from "components/base/TextEditor";
import { useContext } from "react";
import { CustomerContext } from "./CustomerPage";

const CustomerNotesView = () => {
  const { customer, save } = useContext(CustomerContext);
  const modal = useModals();

  function showNoteEditor() {
    modal.present({
      title: "Edit Customer Notes",
      children: (
        <TextEditor initialValue={customer.notes} onSave={didSaveNotes} />
      ),
    });
  }

  function didSaveNotes(value) {
    modal.hide();
    save({
      variables: {
        id: customer.id,
        notes: value,
      },
    });
  }

  return (
    <div className="card">
      <div className="flex justify-between items-baseline">
        <h5>Notes</h5>
        <div>
          <Button onClick={showNoteEditor}>Edit</Button>
        </div>
      </div>
      <div className="opacity-70">Notes for the customer.</div>
      {customer.notes && (
        <div className="mt-2 whitespace-pre-wrap">{customer.notes}</div>
      )}
    </div>
  );
};

export default CustomerNotesView;
